import React from 'react'

type Props = {
  text: string
  className?: string
}

const ErrorText = (props: Props) => {
  const { text, className } = props
  return <small className={`text-red-400 text-start ${className || ''}`}>{text}</small>
}

export default ErrorText
